// Third party
import { useTranslation } from 'react-i18next';
import startCase from 'lodash/startCase';

// Hooks
import { BaseDialog, TDialogAction } from '@mgm/common/components/base';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useAppStore';

// Redux-toolkit
import { memberActions } from '../../../../store/team/slice';

// Components
import { useDeleteMemberAPI } from '../../../../hooks/api';
import { getIsOpenDeleteDialog, getSelectedMember } from '../../../../store/team/selectors';

const DeleteTeamMember = () => {
  const { t } = useTranslation(['team', 'common']);
  const { mutate: deleteMemberMutate, isLoading } = useDeleteMemberAPI();
  const dispatch = useAppDispatch();
  const selectedMember = useAppSelector(getSelectedMember);
  const isOpenDeleteDialog = useAppSelector(getIsOpenDeleteDialog);

  const deleteMember = () => {
    deleteMemberMutate(selectedMember.email);
  };

  const handleCloseDialog = () => {
    dispatch(memberActions.toggleDeleteDialog(false));
  };

  const dialogActions: Array<TDialogAction> = [
    {
      label: t('cancel', { ns: 'common' }),
      variant: 'outlined',
      color: 'primary',
      isDisabled: isLoading,
      onClick: () => handleCloseDialog(),
    },
    {
      label: t('delete', { ns: 'common' }),
      color: 'primary',
      isLoading,
      onClick: () => deleteMember(),
    },
  ];

  return (
    <BaseDialog
      dialogContent={t('deleteMemberMessage', { name: startCase(selectedMember.name) })}
      isOpenDialog={isOpenDeleteDialog}
      dialogTitle={t('deleteMember')}
      handleClose={handleCloseDialog}
      dialogActions={dialogActions}
    />
  );
};

export {
  DeleteTeamMember,
};
